<div fxFlex fxLayout="column" class="add-channels">
  @if (step === 1) {
    <div fxFlex fxLayout="column" fxLayoutAlign="start center">
      <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
        <mat-icon>close</mat-icon>
      </button>
      <div fxFlex fxLayout="column" fxLayoutAlign="start center">
        <div fxFlex="none"
          >Select the messenger that you want to integrate:</div
        >
        <div
          fxFlex
          class="channel-list"
          fxLayout="row wrap"
          fxLayoutAlign="start start"
        >
          @for (provider of providers; track provider) {
            <div
              class="provider-button"
              fxLayout="column"
              fxLayoutAlign="center center"
              (click)="selectProvider(provider)"
            >
              <app-provider-icon
                fxFlex="none"
                [provider]="provider"
              ></app-provider-icon>
              <div fxFlex="none">
                {{ getProviderName(provider) }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (step === 2) {
    <div fxFlex fxLayout="column">
      <div fxFlex="none" fxLayout="row" fxLayoutAlign="space-between stretch">
        <a fxFlex="none" mat-button (click)="init()"
          ><mat-icon>chevron_left</mat-icon> Select another messenger</a
        >
        <a fxFlex="none" mat-button (click)="back()"
          ><mat-icon>close</mat-icon></a
        >
      </div>
      @if (selectedProvider === 'telegram') {
        <app-channels-telegram
          (newChannel)="providerCreated($event)"
        ></app-channels-telegram>
      }
      @if (
        selectedProvider === 'facebook' || selectedProvider === 'instagram'
      ) {
        <app-channels-facebook
          [provider]="selectedProvider"
          (newChannel)="providerCreated($event)"
        ></app-channels-facebook>
      }
      @if (selectedProvider === 'zendesk') {
        <app-channels-zendesk
          (newChannel)="providerCreated($event)"
        ></app-channels-zendesk>
      }
      @if (selectedProvider === 'webchat') {
        <app-channels-webchat
          (newChannel)="providerCreated($event)"
        ></app-channels-webchat>
      }
      @if (selectedProvider === 'whatsapp') {
        <app-channels-whatsapp
          [provider]="selectedProvider"
          (newChannel)="providerCreated($event)"
        ></app-channels-whatsapp>
      }
      @if (selectedProvider === 'whatsapp_playground') {
        <app-channels-whatsapp-playground
          (newChannel)="providerCreated($event)"
        ></app-channels-whatsapp-playground>
      }
      @if (selectedProvider === 'generic') {
        <div class="generic">
          <h3>
            Want to integrate a custom messaging channel like a web based chat
            or an in-app chat?
          </h3>
          <p
            >Contact us at support&#64;hubtype.com and we'll help you set it
            up.</p
          >
        </div>
      }
    </div>
  }

  @if (step === 3) {
    <div fxFlex fxLayout="column" fxLayoutAlign="center center">
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
      <h2 fxFlex="none">Connecting {{ providerAccount?.name }}...</h2>
    </div>
  }

  @if (step === 4) {
    <div fxFlex fxLayout="column">
      <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
        <mat-icon>close</mat-icon>
      </button>
      <h2>Awesome!</h2>
      <p>Your integration is ready.</p>
      <p>
        The {{ providerAccount?.provider }} account "{{
          providerAccount?.name
        }}" is now connected to
        @if (queue) {
          <span>the queue {{ queue.name }}</span>
        }
        @if (bot) {
          <span>the bot {{ bot.name }}</span>
        }
        .
      </p>
      @if (selectedProvider === 'webchat') {
        <div>
          <p>
            In order to use this Webchat, please copy and paste the following
            code in your <b>index.html</b> webpage.
          </p>
          <p>
            For more information, please read our full documentation.
            <a href="https://docs.botonic.io"> Botonic Docs </a>
          </p>
          <app-webchat-snippet
            [showCodeSnippet]="true"
            [providerAccount]="providerAccount"
            [botConfig]="botConfig"
          ></app-webchat-snippet>
        </div>
      }
      @if (selectedProvider === 'whatsapp_playground') {
        <div>
          <p>You can now test your bot on this WhatsApp number:</p>
          <h3>{{ providerAccount?.username }}</h3>
        </div>
      }
      <button
        mat-raised-button
        flex="none"
        type="button"
        class="main-btn"
        (click)="init()"
      >
        Add another messenger
      </button>
      <button mat-button flex="none" type="button" (click)="back()">
        Finish
      </button>
    </div>
  }

  @if (step === 5) {
    <div fxFlex fxLayout="column">
      <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
        <mat-icon>close</mat-icon>
      </button>
      <h2>Ooops...</h2>
      <div fxFlex="none">
        <strong
          >There was a problem connecting {{ providerAccount?.name }}:
          {{ feedback }}</strong
        >
      </div>
      <button
        mat-raised-button
        flex="none"
        type="button"
        class="main-btn"
        (click)="this.step = 2"
      >
        Try again
      </button>
    </div>
  }
</div>
